import React from "react";

function Language() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0001 2C6.48006 2 2.00006 6.48 2.00006 12C2.00006 17.52 6.48006 22 12.0001 22C17.5201 22 22.0001 17.52 22.0001 12C22.0001 6.48 17.5201 2 12.0001 2ZM17.0001 17.47C15.2901 17.47 13.6901 16.73 12.4101 15.36C10.9601 16.67 9.07006 17.47 7.00006 17.47C6.59006 17.47 6.25006 17.13 6.25006 16.72C6.25006 16.31 6.59006 15.97 7.00006 15.97C10.4701 15.97 13.3401 13.22 13.7101 9.7H7.01006C6.60006 9.7 6.26006 9.36 6.26006 8.95C6.26006 8.54 6.60006 8.21 7.01006 8.21H11.2501V7.28C11.2501 6.87 11.5901 6.53 12.0001 6.53C12.4101 6.53 12.7501 6.87 12.7501 7.28V8.21H14.4401C14.4601 8.21 14.4801 8.2 14.5001 8.2C14.5201 8.2 14.5401 8.21 14.5601 8.21H16.9901C17.4001 8.21 17.7401 8.55 17.7401 8.96C17.7401 9.37 17.4001 9.71 16.9901 9.71H15.2101C15.0653 11.3673 14.4514 12.9491 13.4401 14.27C14.4401 15.38 15.6901 15.98 17.0001 15.98C17.4101 15.98 17.7501 16.32 17.7501 16.73C17.7501 17.14 17.4101 17.47 17.0001 17.47Z"
        fill="#51A877"
      />
    </svg>
  );
}

export default Language;
